module.exports = __webpack_public_path__ + "static/media/bkg-actu.ad8dd8e2.jpg";